import React from 'react';
import styled from 'styled-components';

import MainLogo from '@components/navigation/MainLogo';
import { useRecoilValue } from 'recoil';
import {
  layoutDirState,
  layoutTypeState,
  menuTypeState,
  menuWidthState,
} from '@atom/setting/homepageSet';
import { MENU_DESIGN_TYPE } from '@typings/menu/menuType';
import LoginUserSec from '../common/LoginUserSec';
import NavList from '../common/NavList';
import NavIconButtonGroup from '../common/NavIconButtonGroup';
import { LAYOUT_TYPE } from '@typings/setting/layoutType';
import { LAYOUT_DIR } from '@typings/setting/layoutDir';
import { scrollbarHide } from '@styles/variants/scrollbar';

const NavWrapper = styled.nav`
  position: fixed;
  min-width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: center/contain no-repeat;
  z-index: 2;
  overflow-y: auto;
  ${scrollbarHide}
`;

type Props = { align?: 'center' | 'flex-start' };
function MiniHomeNav({ align }: Props) {
  const menuType = useRecoilValue(menuTypeState);
  const layoutType = useRecoilValue(layoutTypeState);
  const layoutDir = useRecoilValue(layoutDirState);
  const menuWidth = useRecoilValue(menuWidthState);

  const InfoWrapMap = {
    [LAYOUT_TYPE.MINIHOME]: (
      <>
        <NavIconButtonGroup
          showLogin={false}
            dropdownDir={layoutDir === LAYOUT_DIR.LEFT ? 'leftTop' : 'rightTop'}
        />
        <LoginUserSec dropdownDir="bottom" size="40px" />
      </>
    ),
    [LAYOUT_TYPE.MEMO]: (
      <NavIconButtonGroup
        showLogin={true}
            dropdownDir={
              layoutDir === LAYOUT_DIR.LEFT ? 'leftBottom' : 'rightBottom'
            }
          />
    ),
  };
  return (
    <NavWrapper
      style={{
        backgroundImage:
          menuType === MENU_DESIGN_TYPE.NONE ||
            menuType === MENU_DESIGN_TYPE.COLOR
            ? ''
            : 'var(--menuImgURL)',
        backgroundColor:
          menuType === MENU_DESIGN_TYPE.COLOR
            ? 'var(--menuBackgroundColor)'
            : '',
        justifyContent: align || 'center',
        width: menuWidth || '220px',
        minWidth: menuWidth || '220px',
      }}
    >
      <MainLogo style={{ maxWidth: '100%', marginBottom: 12 }} />

      <NavList tooltipDir="left" />

      {InfoWrapMap[layoutType]}
    </NavWrapper>
  );
}

export default MiniHomeNav;
